import { a as e, n as t } from "./mathjax-2nQh1S7u.js";
//#region ../../../node_modules/.bun/@mathjax+mathjax-newcm-font@4.1.3/node_modules/@mathjax/mathjax-newcm-font/mjs/chtml/dynamic/sans-serif-r.js
t.dynamicSetup("", "sans-serif-r", e({ SSLR: { "sans-serif": {
	192: [
		.868,
		0,
		.667
	],
	193: [
		.868,
		0,
		.667
	],
	194: [
		.87,
		0,
		.667
	],
	195: [
		.855,
		0,
		.667
	],
	196: [
		.816,
		0,
		.667
	],
	197: [
		.862,
		0,
		.667
	],
	198: [
		.694,
		0,
		.861
	],
	199: [
		.716,
		.214,
		.639
	],
	200: [
		.868,
		0,
		.597
	],
	201: [
		.868,
		0,
		.597
	],
	202: [
		.87,
		0,
		.597
	],
	203: [
		.816,
		0,
		.597
	],
	204: [
		.868,
		0,
		.278
	],
	205: [
		.868,
		0,
		.278,
		{ ic: .112 }
	],
	206: [
		.87,
		0,
		.278,
		{ ic: .022 }
	],
	207: [
		.816,
		0,
		.278
	],
	208: [
		.694,
		0,
		.722
	],
	209: [
		.855,
		0,
		.708
	],
	210: [
		.868,
		.022,
		.736
	],
	211: [
		.868,
		.022,
		.736
	],
	212: [
		.87,
		.022,
		.736
	],
	213: [
		.855,
		.022,
		.736
	],
	214: [
		.816,
		.022,
		.736
	],
	216: [
		.76,
		.066,
		.778
	],
	217: [
		.868,
		.022,
		.688
	],
	218: [
		.868,
		.022,
		.688
	],
	219: [
		.87,
		.022,
		.688
	],
	220: [
		.816,
		.022,
		.688
	],
	221: [
		.868,
		0,
		.667
	],
	222: [
		.694,
		0,
		.583
	],
	223: [
		.705,
		.011,
		.481
	],
	224: [
		.694,
		.011,
		.481
	],
	225: [
		.694,
		.011,
		.481
	],
	226: [
		.697,
		.011,
		.481
	],
	227: [
		.67,
		.011,
		.481
	],
	228: [
		.651,
		.011,
		.481
	],
	229: [
		.685,
		.011,
		.481
	],
	230: [
		.461,
		.011,
		.722
	],
	231: [
		.461,
		.214,
		.444
	],
	232: [
		.694,
		.011,
		.444
	],
	233: [
		.694,
		.011,
		.444
	],
	234: [
		.697,
		.011,
		.444
	],
	235: [
		.651,
		.011,
		.444
	],
	236: [
		.694,
		0,
		.239
	],
	237: [
		.694,
		0,
		.239,
		{ ic: .058 }
	],
	238: [
		.697,
		0,
		.239,
		{ ic: .039 }
	],
	239: [
		.651,
		0,
		.239
	],
	241: [
		.67,
		0,
		.517
	],
	242: [
		.694,
		.011,
		.5
	],
	243: [
		.694,
		.011,
		.5
	],
	244: [
		.697,
		.011,
		.5
	],
	245: [
		.67,
		.011,
		.5
	],
	246: [
		.651,
		.011,
		.5
	],
	248: [
		.558,
		.113,
		.5
	],
	249: [
		.694,
		.011,
		.517
	],
	250: [
		.694,
		.011,
		.517
	],
	251: [
		.697,
		.011,
		.517
	],
	252: [
		.651,
		.011,
		.517
	],
	253: [
		.694,
		.205,
		.461
	],
	254: [
		.694,
		.194,
		.517
	],
	255: [
		.651,
		.205,
		.461
	],
	256: [
		.82,
		0,
		.667
	],
	257: [
		.643,
		.011,
		.481
	],
	258: [
		.924,
		0,
		.667
	],
	259: [
		.7,
		.011,
		.481
	],
	260: [
		.694,
		.212,
		.667
	],
	261: [
		.461,
		.212,
		.481
	],
	262: [
		.868,
		.011,
		.639
	],
	263: [
		.694,
		.011,
		.444
	],
	264: [
		.87,
		.011,
		.639
	],
	265: [
		.697,
		.011,
		.444
	],
	266: [
		.825,
		.011,
		.639
	],
	267: [
		.655,
		.011,
		.444
	],
	268: [
		.87,
		.011,
		.639
	],
	269: [
		.697,
		.011,
		.444
	],
	270: [
		.87,
		0,
		.722
	],
	271: [
		.694,
		.011,
		.517,
		{ ic: .028 }
	],
	272: [
		.694,
		0,
		.722
	],
	273: [
		.694,
		.011,
		.517
	],
	274: [
		.82,
		0,
		.597
	],
	275: [
		.643,
		.011,
		.444
	],
	276: [
		.924,
		0,
		.597
	],
	277: [
		.7,
		.011,
		.444
	],
	278: [
		.825,
		0,
		.597
	],
	279: [
		.655,
		.011,
		.444
	],
	280: [
		.691,
		.212,
		.597
	],
	281: [
		.461,
		.212,
		.444
	],
	282: [
		.87,
		0,
		.597
	],
	283: [
		.697,
		.011,
		.444
	],
	284: [
		.87,
		.011,
		.667
	],
	285: [
		.697,
		.206,
		.5
	],
	286: [
		.924,
		.011,
		.667
	],
	287: [
		.7,
		.206,
		.5
	],
	288: [
		.825,
		.011,
		.667
	],
	289: [
		.655,
		.206,
		.5
	],
	290: [
		.706,
		.266,
		.667
	],
	291: [
		.727,
		.206,
		.5
	],
	292: [
		.87,
		0,
		.708
	],
	293: [
		.87,
		0,
		.517
	],
	294: [
		.694,
		0,
		.708
	],
	295: [
		.694,
		0,
		.517
	],
	296: [
		.855,
		0,
		.278,
		{ ic: .028 }
	],
	297: [
		.67,
		0,
		.239,
		{ ic: .047 }
	],
	298: [
		.82,
		0,
		.278,
		{ ic: .042 }
	],
	299: [
		.643,
		0,
		.239,
		{ ic: .061 }
	],
	300: [
		.924,
		0,
		.278,
		{ ic: .03 }
	],
	301: [
		.7,
		0,
		.239,
		{ ic: .049 }
	],
	302: [
		.694,
		.212,
		.278
	],
	303: [
		.68,
		.212,
		.239
	],
	304: [
		.825,
		0,
		.278
	],
	306: [
		.694,
		.022,
		.722
	],
	307: [
		.655,
		.205,
		.482
	],
	308: [
		.87,
		.022,
		.472,
		{ ic: .034 }
	],
	309: [
		.697,
		.205,
		.267,
		{ ic: .032 }
	],
	310: [
		.694,
		.266,
		.694
	],
	311: [
		.694,
		.266,
		.489
	],
	312: [
		.444,
		0,
		.489
	],
	313: [
		.868,
		0,
		.542
	],
	314: [
		.868,
		0,
		.239,
		{ ic: .138 }
	],
	315: [
		.694,
		.266,
		.542
	],
	316: [
		.694,
		.266,
		.239
	],
	317: [
		.694,
		0,
		.542
	],
	318: [
		.694,
		0,
		.239,
		{ ic: .028 }
	],
	319: [
		.694,
		0,
		.542
	],
	320: [
		.694,
		0,
		.288,
		{ ic: .018 }
	],
	321: [
		.694,
		0,
		.625
	],
	322: [
		.694,
		0,
		.324
	],
	323: [
		.868,
		0,
		.708
	],
	324: [
		.694,
		0,
		.517
	],
	325: [
		.694,
		.266,
		.708
	],
	326: [
		.455,
		.266,
		.517
	],
	327: [
		.87,
		0,
		.708
	],
	328: [
		.697,
		0,
		.517
	],
	329: [
		.623,
		0,
		.645
	],
	330: [
		.716,
		.022,
		.708
	],
	331: [
		.455,
		.209,
		.517
	],
	332: [
		.82,
		.022,
		.736
	],
	333: [
		.643,
		.011,
		.5
	],
	334: [
		.924,
		.022,
		.736
	],
	335: [
		.7,
		.011,
		.5
	],
	336: [
		.913,
		.022,
		.736
	],
	337: [
		.694,
		.011,
		.5
	],
	338: [
		.716,
		.022,
		.972
	],
	339: [
		.461,
		.011,
		.778
	],
	340: [
		.868,
		0,
		.646
	],
	341: [
		.694,
		0,
		.342
	],
	342: [
		.694,
		.266,
		.646
	],
	343: [
		.455,
		.266,
		.342
	],
	344: [
		.87,
		0,
		.646
	],
	345: [
		.697,
		0,
		.342
	],
	346: [
		.868,
		.022,
		.556
	],
	347: [
		.694,
		.011,
		.383
	],
	348: [
		.87,
		.022,
		.556
	],
	349: [
		.697,
		.011,
		.383
	],
	350: [
		.716,
		.214,
		.556
	],
	351: [
		.461,
		.214,
		.383
	],
	352: [
		.87,
		.022,
		.556
	],
	353: [
		.697,
		.011,
		.383
	],
	354: [
		.688,
		.192,
		.681
	],
	355: [
		.571,
		.192,
		.361
	],
	356: [
		.87,
		0,
		.681
	],
	357: [
		.668,
		.011,
		.361
	],
	358: [
		.688,
		0,
		.681
	],
	359: [
		.571,
		.011,
		.361
	],
	360: [
		.855,
		.022,
		.688
	],
	361: [
		.67,
		.011,
		.517
	],
	362: [
		.82,
		.022,
		.688
	],
	363: [
		.643,
		.011,
		.517
	],
	364: [
		.924,
		.022,
		.688
	],
	365: [
		.7,
		.011,
		.517
	],
	366: [
		.862,
		.022,
		.688
	],
	367: [
		.685,
		.011,
		.517
	],
	368: [
		.913,
		.022,
		.688
	],
	369: [
		.694,
		.011,
		.517
	],
	370: [
		.694,
		.212,
		.688
	],
	371: [
		.444,
		.212,
		.517
	],
	372: [
		.87,
		0,
		.944
	],
	373: [
		.697,
		0,
		.683
	],
	374: [
		.87,
		0,
		.667
	],
	375: [
		.697,
		.205,
		.461
	],
	376: [
		.816,
		0,
		.667
	],
	377: [
		.868,
		0,
		.611
	],
	378: [
		.694,
		0,
		.435
	],
	379: [
		.825,
		0,
		.611
	],
	380: [
		.655,
		0,
		.435
	],
	381: [
		.87,
		0,
		.611
	],
	382: [
		.697,
		0,
		.435
	],
	383: [
		.705,
		0,
		.286,
		{ ic: .041 }
	],
	384: [
		.695,
		.011,
		.517
	],
	385: [
		.694,
		0,
		.837
	],
	386: [
		.694,
		0,
		.667
	],
	387: [
		.694,
		.011,
		.517
	],
	388: [
		.703,
		0,
		.667
	],
	389: [
		.709,
		.011,
		.517
	],
	390: [
		.716,
		.022,
		.639
	],
	391: [
		.915,
		.011,
		.639,
		{ ic: .094 }
	],
	392: [
		.678,
		.011,
		.5,
		{ ic: .069 }
	],
	393: [
		.694,
		0,
		.762
	],
	394: [
		.694,
		0,
		.902
	],
	395: [
		.694,
		0,
		.667
	],
	396: [
		.694,
		.011,
		.517
	],
	397: [
		.455,
		.277,
		.472
	],
	398: [
		.691,
		0,
		.597
	],
	399: [
		.716,
		.022,
		.669
	],
	400: [
		.716,
		.022,
		.555
	],
	401: [
		.691,
		.217,
		.569
	],
	402: [
		.705,
		0,
		.306,
		{ ic: .041 }
	],
	403: [
		.915,
		.011,
		.639,
		{ ic: .094 }
	],
	404: [
		.681,
		.206,
		.685,
		{ ic: .002 }
	],
	405: [
		.695,
		.011,
		.728
	],
	406: [
		.694,
		.011,
		.333,
		{ ic: .002 }
	],
	407: [
		.694,
		0,
		.418
	],
	408: [
		.698,
		0,
		.794
	],
	409: [
		.717,
		0,
		.489
	],
	410: [
		.695,
		0,
		.389
	],
	411: [
		.695,
		.012,
		.528
	],
	412: [
		.694,
		.005,
		.794
	],
	413: [
		.694,
		.217,
		.708
	],
	414: [
		.455,
		.195,
		.489
	],
	415: [
		.716,
		.022,
		.736
	],
	416: [
		.778,
		.022,
		.736
	],
	417: [
		.528,
		.011,
		.5
	],
	418: [
		.716,
		.197,
		.839
	],
	419: [
		.461,
		.246,
		.6
	],
	420: [
		.694,
		0,
		.819
	],
	421: [
		.717,
		.195,
		.489
	],
	422: [
		.694,
		.178,
		.646,
		{ ic: .012 }
	],
	423: [
		.717,
		.022,
		.555
	],
	424: [
		.461,
		.011,
		.383
	],
	425: [
		.694,
		0,
		.722
	],
	426: [
		.717,
		.217,
		.358,
		{ ic: .028 }
	],
	427: [
		.571,
		.217,
		.389
	],
	428: [
		.688,
		0,
		.777
	],
	429: [
		.647,
		.011,
		.389
	],
	430: [
		.688,
		.217,
		.681
	],
	431: [
		.778,
		.022,
		.687,
		{ ic: .003 }
	],
	432: [
		.528,
		.011,
		.544
	],
	433: [
		.716,
		0,
		.722
	],
	434: [
		.694,
		.022,
		.688
	],
	435: [
		.698,
		0,
		.767,
		{ ic: .01 }
	],
	436: [
		.446,
		.205,
		.581,
		{ ic: .009 }
	],
	437: [
		.694,
		0,
		.611
	],
	438: [
		.444,
		0,
		.435
	],
	439: [
		.694,
		.022,
		.546
	],
	440: [
		.694,
		.022,
		.546
	],
	441: [
		.445,
		.205,
		.435
	],
	442: [
		.445,
		.205,
		.435
	],
	443: [
		.678,
		0,
		.5
	],
	444: [
		.656,
		.022,
		.5
	],
	445: [
		.428,
		.25,
		.5
	],
	446: [
		.571,
		.011,
		.453
	],
	447: [
		.449,
		.206,
		.461
	],
	448: [
		.695,
		.195,
		.278
	],
	449: [
		.695,
		.195,
		.444
	],
	450: [
		.695,
		.195,
		.556
	],
	451: [
		.695,
		0,
		.319
	],
	452: [
		.889,
		0,
		1.333
	],
	453: [
		.694,
		0,
		1.157
	],
	454: [
		.722,
		.011,
		.952
	],
	455: [
		.694,
		.022,
		1.014
	],
	456: [
		.694,
		.205,
		.809
	],
	457: [
		.722,
		.205,
		.506
	],
	458: [
		.694,
		.022,
		1.18
	],
	459: [
		.694,
		.205,
		.975
	],
	460: [
		.679,
		.205,
		.784
	],
	461: [
		.87,
		0,
		.667
	],
	462: [
		.697,
		.011,
		.481
	],
	463: [
		.87,
		0,
		.278,
		{ ic: .022 }
	],
	464: [
		.697,
		0,
		.239,
		{ ic: .039 }
	],
	465: [
		.87,
		.022,
		.736
	],
	466: [
		.697,
		.011,
		.5
	],
	467: [
		.87,
		.022,
		.688
	],
	468: [
		.697,
		.011,
		.517
	],
	469: [
		1.049,
		.022,
		.688
	],
	470: [
		.812,
		.011,
		.517
	],
	471: [
		.99,
		.022,
		.688
	],
	472: [
		.829,
		.011,
		.517
	],
	473: [
		.992,
		.022,
		.688
	],
	474: [
		.831,
		.011,
		.517
	],
	475: [
		.99,
		.022,
		.688
	],
	476: [
		.829,
		.011,
		.517
	],
	477: [
		.461,
		.011,
		.444
	],
	478: [
		1.049,
		0,
		.667
	],
	479: [
		.812,
		.011,
		.481
	],
	480: [
		1.057,
		0,
		.667
	],
	481: [
		.832,
		.011,
		.48
	],
	482: [
		.837,
		0,
		.861
	],
	483: [
		.616,
		.011,
		.722
	],
	484: [
		.706,
		.011,
		.73
	],
	485: [
		.455,
		.206,
		.57
	],
	486: [
		.87,
		.011,
		.667
	],
	487: [
		.697,
		.206,
		.5
	],
	488: [
		.889,
		0,
		.694
	],
	489: [
		.9,
		0,
		.489
	],
	490: [
		.716,
		.212,
		.736
	],
	491: [
		.461,
		.212,
		.5
	],
	492: [
		.887,
		.212,
		.736
	],
	493: [
		.575,
		.218,
		.5
	],
	494: [
		.889,
		.022,
		.546
	],
	495: [
		.639,
		.205,
		.435
	],
	496: [
		.697,
		.205,
		.267,
		{ ic: .032 }
	],
	497: [
		.694,
		0,
		1.333
	],
	498: [
		.694,
		0,
		1.157
	],
	499: [
		.722,
		.011,
		.952
	],
	500: [
		.868,
		.011,
		.667
	],
	501: [
		.694,
		.206,
		.5
	],
	502: [
		.694,
		.011,
		.996
	],
	503: [
		.721,
		.206,
		.461,
		{ ic: .074 }
	],
	504: [
		.851,
		0,
		.708
	],
	505: [
		.64,
		0,
		.517
	],
	506: [
		1.019,
		0,
		.667
	],
	507: [
		.842,
		.011,
		.481
	],
	508: [
		.868,
		0,
		.861
	],
	509: [
		.694,
		.011,
		.722
	],
	510: [
		.868,
		.066,
		.778
	],
	511: [
		.694,
		.113,
		.5
	],
	512: [
		.913,
		0,
		.667
	],
	513: [
		.694,
		.011,
		.481
	],
	514: [
		.889,
		0,
		.667
	],
	515: [
		.639,
		.011,
		.48
	],
	516: [
		.913,
		0,
		.597
	],
	517: [
		.694,
		.011,
		.444
	],
	518: [
		.889,
		0,
		.597
	],
	519: [
		.639,
		.011,
		.444
	],
	520: [
		.913,
		0,
		.278,
		{ ic: .005 }
	],
	521: [
		.694,
		0,
		.239,
		{ ic: .024 }
	],
	522: [
		.889,
		0,
		.278,
		{ ic: .031 }
	],
	523: [
		.639,
		0,
		.239,
		{ ic: .048 }
	],
	524: [
		.913,
		.022,
		.736
	],
	525: [
		.694,
		.011,
		.5
	],
	526: [
		.889,
		.022,
		.736
	],
	527: [
		.639,
		.011,
		.5
	],
	528: [
		.913,
		0,
		.646
	],
	529: [
		.694,
		0,
		.342
	],
	530: [
		.889,
		0,
		.646
	],
	531: [
		.639,
		0,
		.342,
		{ ic: .031 }
	],
	532: [
		.913,
		.022,
		.688
	],
	533: [
		.694,
		.011,
		.517
	],
	534: [
		.889,
		.022,
		.687
	],
	535: [
		.639,
		.011,
		.517
	],
	536: [
		.716,
		.266,
		.556
	],
	537: [
		.461,
		.266,
		.383
	],
	538: [
		.688,
		.266,
		.681
	],
	539: [
		.571,
		.266,
		.361
	],
	540: [
		.69,
		.054,
		.579
	],
	541: [
		.457,
		.197,
		.48
	],
	542: [
		.889,
		0,
		.708
	],
	543: [
		.9,
		0,
		.517
	],
	544: [
		.71,
		.196,
		.737
	],
	545: [
		.695,
		.146,
		.572,
		{ ic: .022 }
	],
	546: [
		.708,
		.011,
		.5
	],
	547: [
		.656,
		.011,
		.5
	],
	548: [
		.694,
		.186,
		.611
	],
	549: [
		.445,
		.186,
		.49
	],
	550: [
		.855,
		0,
		.667
	],
	551: [
		.679,
		.011,
		.48
	],
	552: [
		.691,
		.194,
		.597
	],
	553: [
		.461,
		.202,
		.444
	],
	554: [
		1.049,
		.022,
		.736
	],
	555: [
		.812,
		.011,
		.5
	],
	556: [
		1.069,
		.022,
		.736
	],
	557: [
		.812,
		.011,
		.5
	],
	558: [
		.855,
		.022,
		.736
	],
	559: [
		.679,
		.011,
		.5
	],
	560: [
		1.057,
		.022,
		.736
	],
	561: [
		.832,
		.011,
		.5
	],
	562: [
		.837,
		0,
		.667
	],
	563: [
		.616,
		.205,
		.461
	],
	564: [
		.694,
		.146,
		.239,
		{ ic: .076 }
	],
	565: [
		.455,
		.146,
		.572,
		{ ic: .023 }
	],
	566: [
		.571,
		.146,
		.361
	],
	568: [
		.695,
		.011,
		.833
	],
	569: [
		.455,
		.195,
		.833
	],
	570: [
		.839,
		.16,
		.667
	],
	571: [
		.839,
		.16,
		.639
	],
	572: [
		.62,
		.16,
		.444
	],
	573: [
		.694,
		0,
		.542
	],
	574: [
		.839,
		.16,
		.681
	],
	575: [
		.461,
		.161,
		.383
	],
	576: [
		.444,
		.184,
		.435
	],
	577: [
		.705,
		0,
		.5
	],
	578: [
		.448,
		0,
		.5
	],
	579: [
		.694,
		0,
		.667
	],
	580: [
		.694,
		.022,
		.688
	],
	581: [
		.694,
		0,
		.667
	],
	582: [
		.839,
		.16,
		.597
	],
	583: [
		.62,
		.16,
		.444
	],
	584: [
		.694,
		.022,
		.472
	],
	585: [
		.655,
		.205,
		.267,
		{ ic: .019 }
	],
	586: [
		.715,
		.218,
		.633,
		{ ic: .079 }
	],
	587: [
		.455,
		.217,
		.517,
		{ ic: .07 }
	],
	588: [
		.694,
		0,
		.666
	],
	589: [
		.455,
		0,
		.342
	],
	590: [
		.694,
		0,
		.667,
		{ ic: .007 }
	],
	591: [
		.444,
		.205,
		.461
	],
	11377: [
		.455,
		0,
		.492
	],
	7680: [
		.694,
		.28,
		.667
	],
	7681: [
		.461,
		.224,
		.48
	],
	7682: [
		.855,
		0,
		.667
	],
	7683: [
		.94,
		.011,
		.517
	],
	7684: [
		.694,
		.148,
		.667
	],
	7685: [
		.722,
		.17,
		.517
	],
	7686: [
		.694,
		.135,
		.667
	],
	7687: [
		.722,
		.158,
		.517
	],
	7688: [
		.851,
		.192,
		.639
	],
	7689: [
		.64,
		.192,
		.444
	],
	7690: [
		.855,
		0,
		.722
	],
	7691: [
		.94,
		.011,
		.517
	],
	7692: [
		.694,
		.2,
		.722
	],
	7693: [
		.694,
		.2,
		.517
	],
	7694: [
		.694,
		.187,
		.722
	],
	7695: [
		.694,
		.187,
		.517
	],
	7696: [
		.694,
		.169,
		.722
	],
	7697: [
		.722,
		.169,
		.517
	],
	7698: [
		.694,
		.231,
		.722
	],
	7699: [
		.722,
		.202,
		.517
	],
	7704: [
		.691,
		.231,
		.597
	],
	7705: [
		.461,
		.202,
		.444
	],
	7706: [
		.691,
		.22,
		.597
	],
	7707: [
		.461,
		.171,
		.444
	],
	7710: [
		.855,
		0,
		.569
	],
	7711: [
		.94,
		0,
		.305,
		{ ic: .042 }
	],
	7712: [
		.837,
		.022,
		.667
	],
	7713: [
		.616,
		.206,
		.5
	],
	7714: [
		.855,
		0,
		.708
	],
	7715: [
		.94,
		0,
		.517
	],
	7716: [
		.694,
		.2,
		.708
	],
	7717: [
		.694,
		.2,
		.517
	],
	7718: [
		.816,
		0,
		.708
	],
	7719: [
		.816,
		0,
		.517
	],
	7722: [
		.694,
		.244,
		.708
	],
	7723: [
		.694,
		.244,
		.517
	],
	7724: [
		.694,
		.22,
		.278,
		{ ic: .027 }
	],
	7725: [
		.679,
		.171,
		.239,
		{ ic: .045 }
	],
	7726: [
		.99,
		0,
		.278,
		{ ic: .062 }
	],
	7727: [
		.829,
		0,
		.239,
		{ ic: .081 }
	],
	7728: [
		.851,
		0,
		.694
	],
	7729: [
		.901,
		0,
		.489
	],
	7730: [
		.694,
		.148,
		.694
	],
	7731: [
		.722,
		.17,
		.489
	],
	7732: [
		.694,
		.135,
		.694
	],
	7733: [
		.722,
		.158,
		.489
	],
	7734: [
		.694,
		.2,
		.542
	],
	7735: [
		.694,
		.2,
		.239
	],
	7736: [
		.82,
		.2,
		.542
	],
	7737: [
		.82,
		.2,
		.239,
		{ ic: .073 }
	],
	7738: [
		.694,
		.135,
		.542
	],
	7739: [
		.722,
		.158,
		.239,
		{ ic: .059 }
	],
	7740: [
		.694,
		.231,
		.542
	],
	7741: [
		.722,
		.202,
		.239,
		{ ic: .039 }
	],
	7742: [
		.851,
		0,
		.875
	],
	7743: [
		.64,
		0,
		.794
	],
	7744: [
		.855,
		0,
		.875
	],
	7745: [
		.679,
		0,
		.794
	],
	7746: [
		.694,
		.2,
		.875
	],
	7747: [
		.455,
		.2,
		.794
	],
	7748: [
		.825,
		0,
		.708
	],
	7749: [
		.655,
		0,
		.517
	],
	7750: [
		.694,
		.2,
		.708
	],
	7751: [
		.455,
		.2,
		.517
	],
	7752: [
		.694,
		.135,
		.708
	],
	7753: [
		.455,
		.158,
		.517
	],
	7754: [
		.694,
		.231,
		.708
	],
	7755: [
		.455,
		.202,
		.517
	],
	7764: [
		.851,
		0,
		.639
	],
	7765: [
		.64,
		.195,
		.517
	],
	7766: [
		.855,
		0,
		.639
	],
	7767: [
		.679,
		.195,
		.517
	],
	7768: [
		.825,
		0,
		.646
	],
	7769: [
		.655,
		0,
		.342
	],
	7770: [
		.694,
		.2,
		.646
	],
	7771: [
		.455,
		.2,
		.342
	],
	7772: [
		.82,
		.2,
		.646
	],
	7773: [
		.643,
		.2,
		.342,
		{ ic: .01 }
	],
	7774: [
		.694,
		.135,
		.646
	],
	7775: [
		.455,
		.158,
		.342
	],
	7776: [
		.855,
		.022,
		.555
	],
	7777: [
		.679,
		.011,
		.383
	],
	7778: [
		.716,
		.2,
		.556
	],
	7779: [
		.461,
		.2,
		.383
	],
	7784: [
		.855,
		.148,
		.555
	],
	7785: [
		.679,
		.17,
		.383
	],
	7786: [
		.855,
		0,
		.68
	],
	7787: [
		.789,
		.011,
		.361
	],
	7788: [
		.688,
		.2,
		.681
	],
	7789: [
		.571,
		.2,
		.361
	],
	7790: [
		.688,
		.187,
		.681
	],
	7791: [
		.571,
		.187,
		.361,
		{ ic: .001 }
	],
	7792: [
		.689,
		.231,
		.68
	],
	7793: [
		.571,
		.202,
		.361
	],
	7794: [
		.694,
		.148,
		.687
	],
	7795: [
		.445,
		.17,
		.517
	],
	7796: [
		.694,
		.22,
		.687
	],
	7797: [
		.445,
		.171,
		.517
	],
	7798: [
		.694,
		.231,
		.687
	],
	7799: [
		.445,
		.202,
		.517
	],
	7804: [
		.889,
		0,
		.667
	],
	7805: [
		.639,
		0,
		.461
	],
	7806: [
		.694,
		.148,
		.667
	],
	7807: [
		.445,
		.17,
		.461
	],
	7808: [
		.868,
		0,
		.944
	],
	7809: [
		.694,
		0,
		.683
	],
	7810: [
		.868,
		0,
		.944
	],
	7811: [
		.694,
		0,
		.683
	],
	7812: [
		.816,
		0,
		.944
	],
	7813: [
		.651,
		0,
		.683
	],
	7814: [
		.855,
		0,
		.944
	],
	7815: [
		.679,
		0,
		.683
	],
	7816: [
		.694,
		.148,
		.944
	],
	7817: [
		.445,
		.17,
		.683
	],
	7818: [
		.855,
		0,
		.667
	],
	7819: [
		.679,
		0,
		.461,
		{ ic: .004 }
	],
	7820: [
		.849,
		0,
		.667
	],
	7821: [
		.66,
		0,
		.461,
		{ ic: .004 }
	],
	7822: [
		.855,
		0,
		.667
	],
	7823: [
		.679,
		.205,
		.461
	],
	7824: [
		.9,
		0,
		.611
	],
	7825: [
		.65,
		0,
		.435
	],
	7826: [
		.694,
		.2,
		.611
	],
	7827: [
		.444,
		.2,
		.435
	],
	7828: [
		.694,
		.135,
		.611
	],
	7829: [
		.445,
		.158,
		.435
	],
	7830: [
		.722,
		.158,
		.517
	],
	7831: [
		.693,
		.011,
		.361
	],
	7832: [
		.639,
		0,
		.683
	],
	7833: [
		.639,
		.205,
		.461
	],
	7835: [
		.94,
		0,
		.305,
		{ ic: .042 }
	],
	7838: [
		.705,
		.011,
		.541
	],
	7840: [
		.694,
		.2,
		.667
	],
	7841: [
		.461,
		.2,
		.481
	],
	7842: [
		.951,
		0,
		.667
	],
	7843: [
		.718,
		.011,
		.481
	],
	7844: [
		1.027,
		0,
		.667
	],
	7845: [
		.816,
		.011,
		.481
	],
	7846: [
		1.027,
		0,
		.667
	],
	7847: [
		.816,
		.011,
		.481
	],
	7848: [
		1.1,
		0,
		.667
	],
	7849: [
		.889,
		.011,
		.481
	],
	7850: [
		1.044,
		0,
		.667
	],
	7851: [
		.833,
		.011,
		.481
	],
	7852: [
		.87,
		.2,
		.667
	],
	7853: [
		.697,
		.2,
		.481
	],
	7854: [
		1.081,
		0,
		.667
	],
	7855: [
		.857,
		.011,
		.481
	],
	7856: [
		1.081,
		0,
		.667
	],
	7857: [
		.857,
		.011,
		.481
	],
	7858: [
		1.154,
		0,
		.667
	],
	7859: [
		.93,
		.011,
		.481
	],
	7860: [
		1.098,
		0,
		.667
	],
	7861: [
		.874,
		.011,
		.481
	],
	7862: [
		.924,
		.2,
		.667
	],
	7863: [
		.7,
		.2,
		.481
	],
	7864: [
		.691,
		.2,
		.597
	],
	7865: [
		.461,
		.2,
		.444
	],
	7866: [
		.951,
		0,
		.597
	],
	7867: [
		.718,
		.011,
		.444
	],
	7868: [
		.855,
		0,
		.597
	],
	7869: [
		.67,
		.011,
		.444
	],
	7870: [
		1.027,
		0,
		.597
	],
	7871: [
		.816,
		.011,
		.444
	],
	7872: [
		1.027,
		0,
		.597
	],
	7873: [
		.816,
		.011,
		.444
	],
	7874: [
		1.1,
		0,
		.597
	],
	7875: [
		.889,
		.011,
		.444
	],
	7876: [
		1.044,
		0,
		.597
	],
	7877: [
		.833,
		.011,
		.444
	],
	7878: [
		.87,
		.2,
		.597
	],
	7879: [
		.697,
		.2,
		.444
	],
	7880: [
		.951,
		0,
		.278
	],
	7881: [
		.718,
		0,
		.239
	],
	7882: [
		.694,
		.2,
		.278
	],
	7883: [
		.655,
		.2,
		.239
	],
	7884: [
		.716,
		.2,
		.736
	],
	7885: [
		.461,
		.2,
		.5
	],
	7886: [
		.951,
		.022,
		.736
	],
	7887: [
		.718,
		.011,
		.5
	],
	7888: [
		1.027,
		.022,
		.736
	],
	7889: [
		.816,
		.011,
		.5
	],
	7890: [
		1.027,
		.022,
		.736
	],
	7891: [
		.816,
		.011,
		.5
	],
	7892: [
		1.1,
		.022,
		.736
	],
	7893: [
		.889,
		.011,
		.5
	],
	7894: [
		1.044,
		.022,
		.736
	],
	7895: [
		.833,
		.011,
		.5
	],
	7896: [
		.87,
		.2,
		.736
	],
	7897: [
		.697,
		.2,
		.5
	],
	7898: [
		.868,
		.022,
		.736
	],
	7899: [
		.694,
		.011,
		.5
	],
	7900: [
		.868,
		.022,
		.736
	],
	7901: [
		.694,
		.011,
		.5
	],
	7902: [
		.951,
		.022,
		.736
	],
	7903: [
		.718,
		.011,
		.5
	],
	7904: [
		.855,
		.022,
		.736
	],
	7905: [
		.67,
		.011,
		.5
	],
	7906: [
		.778,
		.2,
		.736
	],
	7907: [
		.528,
		.2,
		.5
	],
	7908: [
		.694,
		.2,
		.688
	],
	7909: [
		.444,
		.2,
		.517
	],
	7910: [
		.951,
		.022,
		.688
	],
	7911: [
		.718,
		.011,
		.517
	],
	7912: [
		.868,
		.022,
		.687,
		{ ic: .003 }
	],
	7913: [
		.694,
		.011,
		.544
	],
	7914: [
		.868,
		.022,
		.687,
		{ ic: .003 }
	],
	7915: [
		.694,
		.011,
		.544
	],
	7916: [
		.951,
		.022,
		.687,
		{ ic: .003 }
	],
	7917: [
		.718,
		.011,
		.544
	],
	7918: [
		.855,
		.022,
		.687,
		{ ic: .003 }
	],
	7919: [
		.67,
		.011,
		.544
	],
	7920: [
		.778,
		.2,
		.687,
		{ ic: .003 }
	],
	7921: [
		.528,
		.2,
		.544
	],
	7922: [
		.868,
		0,
		.667
	],
	7923: [
		.694,
		.205,
		.461
	],
	7924: [
		.694,
		.2,
		.667
	],
	7925: [
		.444,
		.205,
		.461
	],
	7926: [
		.951,
		0,
		.667
	],
	7927: [
		.718,
		.205,
		.461
	],
	7928: [
		.855,
		0,
		.667
	],
	7929: [
		.67,
		.205,
		.461
	]
} } }, "NCM"), {}, ["MJX-NCM-SSLR"]);
//#endregion
